<template>
  <div class="dictList">
    <Form ref="form1" :model="search" :label-width="80" class="dictList-top">
      <FormItem label="类型名称" class="w20 min_width">
        <Input
          v-model.trim="search.itemName"
          placeholder="请输入类型名称"
          @on-enter="checkList"
          @on-blur="checkList"
          clearable
          @on-clear="checkList"
        ></Input>
      </FormItem>
      <FormItem label="类型编码" class="w20 min_width">
        <Input
          v-model.trim="search.type"
          placeholder="请输入类型编码"
          @on-enter="checkList"
          @on-blur="checkList"
          clearable
          @on-clear="checkList"
        ></Input>
      </FormItem>
    </Form>
    <Table :columns="dataCol" :loading="tableLoading" :data="dataList">
      <!-- 操作 -->
      <template slot-scope="{ row }" slot="action">
        <span
          class="fontblue fontcursor mr-16"
          @click="seeDetail(row)"
          v-permission="['detail']"
          >详情</span
        >
        <!-- <span
          class="fontblue fontcursor mr-16"
          @click="seeEdit(row)"
          v-if="row.type != 'SERVICE_SCENE' && row.type != 'SCENE_SERVICE_TYPE'"
          v-permission="['update']"
        >编辑</span>-->
        <!-- 仅供测试用 -->
        <span
          class="fontblue fontcursor mr-16"
          v-if="row.editable"
          @click="seeEdit(row)"
          v-permission="['update']"
          >编辑</span
        >
      </template>
    </Table>
    <Row class="mt-16 mr-32" type="flex" justify="end">
      <Page
        :total="pageTotal"
        :page-size="search.pageSize"
        :page-size-opts="psize"
        :current="search.pageIndex"
        @on-change="handlePage"
        @on-page-size-change="sizeChange"
        show-sizer
        show-total
        show-elevator
        placement="top"
        class-name="page"
      />
    </Row>
    <EditDict
      v-if="showEdit"
      @confirm="getList"
      :dialog.sync="showEdit"
      :form="formInfo"
    />
    <DictInfo v-if="showDetail" :dialog.sync="showDetail" :form="formInfo" />
  </div>
</template>

<script>
import { getParamList, getItems, getEditData } from "@/api/system";
import EditDict from "../components/dict/EditDict";
import DictInfo from "../components/dict/DictInfo";
import expandRow from "../components/dict/ExpandRow";

const dataCol = [
  {
    type: "expand",
    width: 50,
    render: (h, params) => {
      return h(expandRow, {
        props: {
          row: params.row,
        },
      });
    },
  },
  {
    title: "类型名称",
    key: "itemName",
    tooltip: true,
    minWidth: 100,
  },
  {
    title: "类型编码",
    key: "type",
    tooltip: true,
    minWidth: 150,
  },
  {
    title: "创建时间",
    key: "createTime",
    tooltip: true,
    minWidth: 210,
  },
  {
    title: "操作",
    slot: "action",
    minWidth: 120,
  },
];
export default {
  components: { EditDict, DictInfo },
  data() {
    return {
      tableLoading: false,
      pageTotal: 0,
      psize: [10, 20, 50, 100],
      dataCol: dataCol,
      dataList: [],
      search: {
        pageIndex: 1,
        pageSize: 10,
      },
      showEdit: false,
      showDetail: false,
      formInfo: {},
    };
  },
  watch: {
    //解决当前页最后一条删除后，没有自动折页的问题
    pageTotal() {
      const cPage = this.pageTotal / this.search.pageSize;
      if (this.search.pageIndex === cPage + 1 && this.search.pageIndex != 1) {
        this.search.pageIndex = this.search.pageIndex - 1;
        this.getList(); //获取列表数据
      }
    },
  },
  created() {
    this.getList();
  },
  computed: {},
  methods: {
    seeEdit(row) {
      if (!row.tag) {
        row.tag = [];
      }
      this.formInfo = JSON.parse(JSON.stringify(row));
      this.showEdit = true;
      // getEditData(row.id).then((res) => {
      //   console.log(res, "字典==编辑数据回显");
      // });
    },
    seeDetail(row) {
      if (!row.tag) {
        row.tag = [];
      }
      this.formInfo = JSON.parse(JSON.stringify(row));
      this.showDetail = true;
    },
    getItems(row, type) {
      getItems(row.id).then((res) => {
        console.log(res, row, "获取子字典项");
        let data = JSON.parse(JSON.stringify(row));
        data.children = res.data.data;
        this.formInfo = data;
        if (type == "edit") {
          this.showEdit = true;
        } else {
          this.showDetail = true;
        }
      });
    },
    // 查询
    checkList() {
      this.search.pageIndex = 1;
      this.search.pageSize = 10;
      this.getList();
    },
    getList() {
      let query = this.search;
      getParamList(query).then((res) => {
        console.log(res, "字典列表");
        let json = res.data.data;
        json.forEach((item) => {
          item.tag = item.children;
          delete item.children;
        });
        this.dataList = res.data.data;
        this.pageTotal = res.data.page.totalCount;
      });
    },
    delData(id) {
      this.$Modal.confirm({
        title: "确认删除",
        content: "确认当前数据吗？",
        onOk: () => {
          this.delConfirm(id);
        },
        onCancel: () => {},
      });
    },
    delConfirm(id) {
      return;
      deleteApp(id).then((res) => {
        console.log(res, "删除-res");
        self.$Message.success("删除成功");
        self.getList();
      });
    },
    // 分页==页码修改(ok)
    handlePage(value) {
      let self = this;
      self.search.pageIndex = value;
      self.getList();
    },
    // 分页==每页显示数量修改(ok)
    sizeChange(value) {
      let self = this;
      self.search.pageSize = value;
      self.$nextTick(() => {
        self.getList();
      });
    },
  },
};
</script>

<style lang="scss">
.dictList {
  width: 100%;
  height: 100%;
  background: #fff;
  padding: 20px;
  overflow-y: auto;
  &-top {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .min_width {
      min-width: 232px;
    }
  }
}
</style>
